import React, { useState } from "react";
import "../Styles/PhysicalAttributes.css";
import RangeSlider from "./RangeSlider";

const PhysicalAttributes = ({   skinToneList,
  physicalbuildList,
  unit, setUnit,
  skinIdeal, setSkinIdeal,
  skinOpen, setSkinOpen,
  buildIdeal, setBuildIdeal,
  buildOpen, setBuildOpen,
  heightRange, setHeightRange,
  weightRange, setWeightRange,
  noPrefHeight, setNoPrefHeight,
  noPrefWeight, setNoPrefWeight
 }) => {
 

  const renderSkinToneOptions = () => {
    return skinToneList.map((item) => (
      <option key={item.SkinToneId} value={item.SkinToneId}>
        {item.SkinToneName}
      </option>
    ));
  };
  const renderBuildOptions = () => {
    return physicalbuildList.map((item) => (
      <option key={item.BuildId} value={item.BuildId}>
        {item.BuildName}
      </option>
    ));
  };

  const toggleOption = (option, stateList, setStateList) => {
    if (stateList.includes(option)) {
      setStateList(stateList.filter((item) => item !== option));
    } else {
      setStateList([...stateList, option]);
    }
  };

  return (
    <div className="container-1 p-4 mt-4">
      <h2 className="section-title">Physical Attributes</h2>

      {/* Unit system */}
      {/* <div className="attribute-section">
        <label className="label-title">Unit system</label>
        <div className="unit-options">
          <label>
            <input
              type="radio"
              checked={unit === "metric"}
              onChange={() => setUnit("metric")}
            />
            <span>Metric system (cm/kg)</span>
          </label>
          <label>
            <input
              type="radio"
              checked={unit === "imperial"}
              onChange={() => setUnit("imperial")}
            />
            <span>Imperial system (ft/lb)</span>
          </label>
        </div>
      </div> */}

      <RangeSlider
        label="Height"
        unit="ft"
        min={3}
        max={10}
        step={0.1}
        values={heightRange}
        setValues={setHeightRange}
        leftLabel="3FT OR LOWER"
        rightLabel="10 FT OR MORE"
        colorClass="primary"
        noPref={noPrefHeight}
        setNoPref={setNoPrefHeight}
      />

      <RangeSlider
        label="Weight"
        unit="kg"
        min={20}
        max={150}
        step={1}
        values={weightRange}
        setValues={setWeightRange}
        leftLabel="20kg or lower"
        rightLabel="150 kg or more"
        colorClass="secondary"
        noPref={noPrefWeight}
        setNoPref={setNoPrefWeight}
      />

      {/* Skin complexion */}
      <div className="attribute-section">
        <label className="label-title">Skin complexion</label>
        <div className="sub-label">Ideal</div>
        <select
          value={skinIdeal}
          onChange={(e) => setSkinIdeal(e.target.value)}
        >
          {renderSkinToneOptions()}
        </select>
        <div className="sub-label">Open to</div>
        <div className="options-chips">
          {skinToneList.map((option, index) => (
            <button
              key={index}
              className={`chip ${skinOpen.includes(option.SkinToneId) ? "selected" : ""} click-effect`}
              onClick={() => toggleOption(option.SkinToneId, skinOpen, setSkinOpen)}
            >
              {option.SkinToneName}
            </button>
          ))}
        </div>
      </div>

      {/* Build */}
      <div className="attribute-section">
        <label className="label-title">Build</label>
        <div className="sub-label">Ideal</div>
        <select
          value={buildIdeal}
          onChange={(e) => setBuildIdeal(e.target.value)}
        >
          <option value="">Select build</option>
          {renderBuildOptions()}
        </select>
         <div className="sub-label">Open to</div>
        <div className="options-chips">
          {physicalbuildList.map((option, index) => (
            <button
              key={index}
              className={`chip ${buildOpen.includes(option.BuildId) ? "selected" : ""} click-effect`}
              onClick={() => toggleOption(option.BuildId, buildOpen, setBuildOpen)}
            >
              {option.BuildName}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhysicalAttributes;
